// Diário › Quadro dos Sonhos (0.65): mural de fotos (vision board) com legenda, organizado arrastando,
// e cada foto pode ser ligada a um sonho do Projeto de Vida.
import { useState } from 'react';
import { Alert, Dimensions, Image, Pressable, Text, View } from 'react-native';
import { gravarSonhos, lerMetas, lerSonhos, useDiario, type FotoSonho, abrirDaLixeira, selarParaLixeira } from '../../store/diario';
import { Ordenavel } from '../Arrastar';
import { fonteImagem } from '../Anexos';
import { Btn, Chip, Field, Screen, Sheet } from '../ui';
import { C } from '../theme';
import { Corpo } from './comum';
import { useAnexar } from '../MenuAnexo';
import { paraLixeira, registrarRestauro } from '../../lib/lixeira';
import { uid } from '../../lib/date';
import { t } from '../../lib/i18n';
import { useBotaoNovo } from '../../lib/botaoNovo';

registrarRestauro('diario-sonho', (c: unknown) => { const f = abrirDaLixeira<FotoSonho>(c); if (!lerSonhos().some(x => x.id === f.id)) gravarSonhos([...lerSonhos(), f]); });

export function QuadroSonhos({ cor, onBack }: { cor: string; onBack: () => void }) {
  useDiario();
  const fotos = lerSonhos();
  const [ed, setEd] = useState<FotoSonho | null>(null);
  const anexo = useAnexar({ cor });   // 0.72 (11g): Fotos · Tirar foto · Arquivos
  const [quebrada, setQuebrada] = useState<Record<string, boolean>>({});
  useBotaoNovo({ rotulo: t('Adicionar foto'), fn: () => { adicionar(); } });   // 11d F
  const larg = (Dimensions.get('window').width - 32 - 10) / 2;
  async function adicionar() {
    try {
      const r = await anexo.anexar({ tipo: 'imagem', titulo: t('Adicionar foto') });
      if (!r) return;
      const f: FotoSonho = { id: uid(), arq: r.anexo, legenda: '', meta: null };
      gravarSonhos([...lerSonhos(), f]);
      setEd(f);
      if (r.aviso) Alert.alert(t('Foto adicionada'), r.aviso);
    } catch (e: any) { Alert.alert(t('Não foi possível'), String(e?.message ?? e)); }
  }
  const metas = lerMetas();
  return (
    <Screen title={t('Quadro dos Sonhos')} onBack={onBack}>
      <Text style={{ color: C.sub, fontSize: 13 }}>{t('Junte fotos do que você quer viver. Segure e arraste para organizar.')}</Text>
      <Ordenavel grade itens={fotos} chave={f => f.id} gap={10} onOrdem={gravarSonhos} estiloItem={() => ({ width: larg })}
        render={f => {
          const src = fonteImagem(f.arq);
          const meta = metas.find(m => m.id === f.meta);
          return (
            <Pressable onPress={() => setEd(f)} style={{ backgroundColor: C.card, borderRadius: 14, overflow: 'hidden' }}>
              {src && !quebrada[f.id]
                ? <Image source={{ uri: src }} style={{ width: larg, height: larg * 1.2 }} resizeMode="cover" onError={() => setQuebrada(q => ({ ...q, [f.id]: true }))} />
                : <View style={{ width: larg, height: larg * 1.2, alignItems: 'center', justifyContent: 'center' }}><Text style={{ color: C.sub, fontSize: 12, textAlign: 'center' }}>🖼️ {t('Imagem não encontrada')}</Text></View>}
              {(!!f.legenda || !!meta) && (
                <View style={{ padding: 8, gap: 2 }}>
                  {!!f.legenda && <Text style={{ color: C.text, fontSize: 13 }} numberOfLines={2}>{f.legenda}</Text>}
                  {!!meta && <Text style={{ color: cor, fontSize: 11 }} numberOfLines={1}>🌟 {meta.titulo}</Text>}
                </View>
              )}
            </Pressable>
          );
        }} />
      {!fotos.length && <Text style={{ color: C.sub }}>{t('Nenhuma foto ainda.')}</Text>}
      <Pressable onPress={adicionar} style={{ backgroundColor: cor, borderRadius: 14, padding: 14, alignItems: 'center', marginTop: 6 }}>
        <Text style={{ color: '#fff', fontWeight: '800' }}>+ {t('Adicionar foto')}</Text>
      </Pressable>
      <View style={{ height: 60 }} />
      <Sheet visible={!!ed} onClose={() => setEd(null)} title={t('Foto do sonho')}>
        {!!ed && (
          <Corpo>
            {fonteImagem(ed.arq) ? <Image source={{ uri: fonteImagem(ed.arq)! }} style={{ width: '100%', height: 260, borderRadius: 14 }} resizeMode="contain" /> : null}
            <Field value={ed.legenda} onChangeText={v => setEd({ ...ed, legenda: v })} placeholder={t('Legenda (opcional)')} />
            <Text style={{ color: C.sub, fontSize: 12, fontWeight: '800' }}>{t('LIGAR A UM SONHO DO PROJETO DE VIDA (OPCIONAL)')}</Text>
            <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6 }}>
              <Chip small cor={cor} on={!ed.meta} label={t('Nenhum')} onPress={() => setEd({ ...ed, meta: null })} />
              {metas.filter(m => !m.concluida).map(m => <Chip key={m.id} small cor={cor} on={ed.meta === m.id} label={`${m.icone} ${m.titulo}`} onPress={() => setEd({ ...ed, meta: m.id })} />)}
            </View>
            <Btn cor={cor} label={t('Salvar')} onPress={() => { gravarSonhos(lerSonhos().map(x => (x.id === ed.id ? ed : x))); setEd(null); }} />
            <Pressable onPress={() => Alert.alert(t('Tirar esta foto do quadro?'), t('Fica 30 dias na lixeira.'), [{ text: t('Cancelar'), style: 'cancel' }, { text: t('Tirar'), style: 'destructive', onPress: () => { paraLixeira('diario', 'diario-sonho', t('Foto do Quadro dos Sonhos'), selarParaLixeira(ed)); gravarSonhos(lerSonhos().filter(x => x.id !== ed.id)); setEd(null); } }])} style={{ padding: 10, alignItems: 'center' }}>
              <Text style={{ color: C.danger }}>🗑 {t('Excluir')}</Text>
            </Pressable>
          </Corpo>
        )}
      </Sheet>
      {anexo.tela}
    </Screen>
  );
}
